import { Component, inject, OnInit } from '@angular/core';
import { ActivationEnd, Router } from '@angular/router';
import { distinctUntilChanged, filter, map } from 'rxjs';
import { EDI_MAPPING_MODELLER_FEATURE_ID } from '../../../models/edi-mapping-modeller';
import { BackendFeatureService } from '../../../services/backend-feature.service';
import { EdiWrapperTile, EdiWrapperTilesService } from './edi-wrapper-tiles.service';

@Component({
  selector: 'lib-edi-wrapper',
  templateUrl: './edi-wrapper.component.html',
  styleUrls: ['./edi-wrapper.component.css'],
  standalone: false
})
export class EdiWrapperComponent implements OnInit {
  protected router = inject(Router);
  protected backendFeatureService = inject(BackendFeatureService);
  protected ediWrapperTilesService = inject(EdiWrapperTilesService);

  minimize = false;
  incomingOrderResponsesEnabled = false;
  pricatsEnabled = false;
  configurationsEnabled = false;
  documentViewerEnabled = false;
  mappingModellerEnabled = false;
  extraTiles: EdiWrapperTile[] = [];

  constructor() {
    this.router.events
      .pipe(
        filter(event => event instanceof ActivationEnd),
        filter(event => (event as ActivationEnd).snapshot.component === EdiWrapperComponent),
        map(event => (event as ActivationEnd).snapshot.children.length),
        distinctUntilChanged()
      )
      .subscribe(children => (this.minimize = children !== 0));
    this.minimize = !this.router.url.endsWith('/edi');

    this.backendFeatureService.isActivated('gung-feature-edi.incoming-order-responses').subscribe(isActivated => {
      if (isActivated) {
        this.incomingOrderResponsesEnabled = true;
      }
    });

    this.backendFeatureService.isActivated('gung-feature-edi.pricats').subscribe(isActivated => {
      if (isActivated) {
        this.pricatsEnabled = true;
      }
    });

    this.backendFeatureService.isActivated('gung-feature-edi.configurations').subscribe(isActivated => {
      if (isActivated) {
        this.configurationsEnabled = true;
      }
    });

    this.backendFeatureService.isActivated('gung-feature-edi.document-viewer').subscribe(isActivated => {
      if (isActivated) {
        this.documentViewerEnabled = true;
      }
    });

    this.backendFeatureService.isActivated(EDI_MAPPING_MODELLER_FEATURE_ID).subscribe(isActivated => {
      if (isActivated) {
        this.mappingModellerEnabled = true;
      }
    });
  }

  ngOnInit() {
    this.extraTiles = this.ediWrapperTilesService.getExtraTiles();
  }
}
